import React from 'react'
import List from 'src/modules/ELearning/Collection/List'

const ElearningCollectionListPage = () => {
  return <List />
}

export default ElearningCollectionListPage
